module.exports = __webpack_public_path__ + "media/src/public/img/main-bg1-fad331581c87bffcb679f6c19fcc3dfb.jpg";